import { render } from "./QuizzesPage.vue?vue&type=template&id=2872293b&scoped=true"
import script from "./QuizzesPage.vue?vue&type=script&lang=js"
export * from "./QuizzesPage.vue?vue&type=script&lang=js"

import "./QuizzesPage.vue?vue&type=style&index=0&id=2872293b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2872293b"]])

export default __exports__